import { Box, useMediaQuery } from '@chakra-ui/react';
import { RecipeDetailResponse } from '@diamond/shared/types';
import { Breadcrumbs } from '@diamond/shared/ui';
import { SEONext } from '@diamond/sol-buyer/seo-next';
import { useRouteQuery } from '@diamond/sol-buyer/utils';

import { BleedBackground } from '../../layouts';
import { RecipeDetailView } from './RecipeDetail';
import { RecipeDetailMobile } from './RecipeDetailMobile';

interface RecipeDetailContentProps {
  data: RecipeDetailResponse;
  onClickHandleFavorite: (id: string) => void;
  isAuthenticated: boolean;
}

export const RecipeDetailContent = ({
  data,
  onClickHandleFavorite,
  isAuthenticated,
}: RecipeDetailContentProps) => {
  const slug = useRouteQuery()['recipesId'];
  const [isMobile] = useMediaQuery('(max-width: 992px)');

  return (
    <Box pos="relative" pb="6">
      <SEONext title="Recipes" />
      <BleedBackground
        bgImage="url('/images/recipe-pattern.png')"
        bgRepeat="repeat"
        bgSize="12px"
        bgColor="#FEF9F2"
        backgroundBlendMode="luminosity"
        isMainBg
      />
      <Box display={{ base: 'none', md: 'block' }} mb="6">
        <Breadcrumbs
          links={[
            { link: '/', title: 'Beranda' },
            { link: '/recipes', title: 'Resep Chef Sukanda Djaya' },
            { link: `/recipes/${slug}`, title: data.title },
          ]}
        />
      </Box>
      <Box>
        {isMobile ? (
          <RecipeDetailMobile
            data={data}
            onFavoriteClick={onClickHandleFavorite}
            isAuthenticated={isAuthenticated}
          />
        ) : (
          <RecipeDetailView
            data={data}
            onClickHandleFavorite={onClickHandleFavorite}
            isAuthenticated={isAuthenticated}
          />
        )}
      </Box>
    </Box>
  );
};
